import { memo } from 'react';
import { IWordSliderProps } from './WordSlider.types';
import styles from './styles.module.scss';

/**
 * This component is only used in the HeroContent component.
 * */
export const WordSlider = memo<IWordSliderProps>(({ words }) => (
  <div className={styles.container}>
    <ul className={styles.wrapper}>
      {[...words, [words[0]]].map((word, index) => (
        <li key={`${word}-${index.toString()}`} className={styles.word}>
          {word}
        </li>
      ))}
    </ul>
  </div>
));

WordSlider.displayName = 'WordSlider';

export default WordSlider;
